export const TIPOS_VINCULO_CUENTA = {
    10: 'TipoVinculoInmueble',
    11: 'TipoVinculoComercio',
    12: 'TipoVinculoVehiculo',
    13: 'TipoVinculoCementerio',
    14: 'TipoVinculoFondeadero',
    15: 'TipoVinculoEspecial',
}

export const initialFormValues = {
    id: -1,
    idEstadoPlanPagoDefinicion: 0,
    idTipoPlanPago: 0,
    idTipoTributo: 0,
    idTasaPlanPago: 0,
    idSubTasaPlanPago: 0,
    codigo: '',
    descripcion: '',
    fechaDesde: null,
    fechaHasta: null,
    cuotaDesde: 0,
    cuotaHasta: 0,
    periodicidad: 1,
    idTipoVencimientoAnticipo: 0,
    idTipoVencimientoCuota1: 0,
    idTipoVencimientoCuotas: 0,
    vencimientoEncadenado: false,
    idTipoAlcanceTemporal: 0,
    fechaDesdeAlcanceTemporal: null,
    fechaHastaAlcanceTemporal: null,
    mesDesdeAlcanceTemporal: 0,
    mesHastaAlcanceTemporal: 0,
    aplicaDerechosEspontaneos: false,
    aplicaCancelacionAnticipada: false,
    aplicaTotalidadDeudaAdministrativa: false,
    aplicaDeudaAdministrativa: false,
    aplicaDeudaLegal: false,
    incluyeDeudaNoVencida: false,
    noAplicaDeudoresDDJJ: false,
    cobraSellados: true,
    montoDeudaAdministrativaDesde: 0,
    montoDeudaAdministrativaHasta: 0,
    montoCuotaDesde: 0,
    montoCuotaHasta: 0,
    idTipoCalculoInteres: 0,
    idTipoCobroAccesorios: 0,
    idViaConsolidacion: 0,
    idTipoTratamientoPagos: 780,
    idTipoTratamientoDebitoAutomatico: 800,
    idUsuarioCreacion: 0,
    fechaCreacion: null
}

export const initialOtherValues = {
    archivos: [],
    observaciones: [],
    etiquetas: [],
    planPagosDefinicionAlcanceTasa: [],
    planPagosDefinicionAlcanceRubro: [],
    planPagosDefinicionAlcanceGrupo: [],
    planPagosDefinicionAlcanceZonaTarifaria: [],
    planPagosDefinicionAlcanceTipoCondicionEspecial: [],
    planPagosDefinicionAlcanceCondicionFiscal: [],
    planPagosDefinicionAlcanceRubroAfip: [],
    planPagosDefinicionAlcanceFormaJuridica: [],
    planPagosDefinicionQuitaCuota: [],
    planPagosDefinicionInteres: [],
    planPagosDefinicionAnticipoCuota: [],
    planPagosDefinicionCaducidadCuota: [],
    planPagosDefinicionTipoVinculoCuenta: [],
}

export const formatDataForPost = (data, otherValues) => {
    const newOtherValues = {}
    Object.keys(otherValues).forEach(key => {
        if (key === 'planPagoDefinicion') return
        if (key === 'planPagosDefinicionTipoVinculoCuenta') {
            newOtherValues[key] = otherValues[key].filter(item => !(item.state === 'r' && item.id < 0))
        } else {
            newOtherValues[key] = otherValues[key].filter(item => item.state !== 'o' && !(item.state === 'r' && item.id < 0))
        }
    })
    return {
        ...newOtherValues,
        planPagoDefinicion: data,
    }
}

// cada icono se dibuja solo si le pasaron su callback: una grilla que no tiene nada
// que ver ni que editar (el alcance por tasas) pide solo onAdd y onRemove
export const buildCellAVMR = ({ onAdd, onView, onModify, onRemove, readOnly }) => ({
    id:'abm', accessor: 'id', width: '10%', disableGlobalFilter: true, disableSortBy: true,
    Header: (props) => readOnly ? <div/> : (
        <div className='action'>
            <div onClick={onAdd} className="link">
                <span className="material-symbols-outlined" title="Nuevo">add</span>
            </div>
        </div>
    ),
    Cell: (props) =>  (
        <div className='action'>
            {onView && <div onClick={() => onView(props.row.original)} className="link">
                <span className="material-symbols-outlined" title="Ver">search</span>
            </div>}
            {!readOnly && <>
                {onModify && <div onClick={() => onModify(props.row.original)} className="link">
                <span className="material-symbols-outlined" title="Modificar">stylus</span>
                </div>}
                {onRemove && <div onClick={() => onRemove(props.row.original)} className="link">
                <span className="material-symbols-outlined" title="Eliminar">delete</span>
                </div>}
            </>}
        </div>
    ),
})
